// Configure Amplify as an import side-effect so it runs before any module
// (e.g. the Vuex auth module's `init`) touches `Auth`. ES module imports are
// hoisted, so importing this first in main.js guarantees configuration order.
import Amplify from '@aws-amplify/core'
import awsExports from '../aws-exports'

Amplify.Logger.LOG_LEVEL =
  process.env.NODE_ENV === 'production' ? 'ERROR' : 'DEBUG'
Amplify.configure(awsExports)
